import React, {Component} from 'react';
import { connect } from 'react-redux';
import { Snackbar } from 'material-ui';

class NotifySnackBar extends Component {

    constructor(props, context) {
        super(props, context);

        this.handleRequestClose = this.handleRequestClose.bind(this);
    }

    handleRequestClose() {
        this.props.onCloseSnackbar();
    }

    render() {

        const { hasMessage, message } = this.props;


        return (
            <div>
                <Snackbar
                    open={hasMessage}
                    message={message}
                    autoHideDuration={10000}
                    onRequestClose={this.handleRequestClose}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    hasMessage: state.common.hasMessage || false,
    message: state.common.message || "",
});

const mapDispatchToProps = dispatch => ({
    onCloseSnackbar: () =>
        dispatch({type: 'NOTIFY_USER_CLOSE', payload: false})
})

NotifySnackBar = connect(mapStateToProps, mapDispatchToProps)(NotifySnackBar);

export default NotifySnackBar;
